export default "__VITE_ASSET__B4Mf1d3P__"